import Scoreboard from "./scoreboard_components/Scoreboard.js";
import SelectionMenu from "./scoreboard_components/SelectionMenu.js";
import React, { useState } from "react";
import "./App.css";

function App() {
  const [mapsize, setMapsize] = useState("Both");
  const [difficulty, setDifficulty] = useState("Any");

  return (
    <div className="scoreboardcontainer">
      <div className="title">Robin The Hood Leaderboard</div>
      <h1>Map Size</h1>
      <SelectionMenu
        options={["Both", "Small", "Large"]}
        selected={mapsize}
        setSelected={setMapsize}
      />
      <h1>Difficulty</h1>
      <SelectionMenu
        options={["Any", "Easy", "Medium", "Hard"]}
        selected={difficulty}
        setSelected={setDifficulty}
      />
      <Scoreboard className="parent" options={{ mapsize, difficulty }} />
    </div>
  );
}

export default App;
